export const dashboardRoutes = {
  label: 'Propriétés',
  labelDisable: true,

  children: [
    {
      name: 'Tableau de bord',
      active: true,
      to: '/',
      icon: 'chart-pie',
    },
    {
      name: 'Propriétés',
      active: true,
      to: '/villas',
      icon: 'home', 
    },
    {
      name: 'Recherche',
      icon: 'search',
      to: '/search',
      active: true, 
    },
  ]
}; 

export default [
  dashboardRoutes,
];
